import { addYears, getYearDiff } from 'lib/dateUtils'

export const arrayOfYears = (range: number) => {
  const years = []
  let dateStart = new Date()
  const dateEnd = addYears(dateStart, range)
  while (getYearDiff(dateStart, dateEnd) !== 0) {
    years.push(dateStart.getFullYear())
    dateStart = addYears(dateStart, 1)
  }
  return years
}
